import React from 'react';
import { Home, Bell, Settings } from 'lucide-react';

interface SidebarProps {
  currentPage: string;
  activeAlertsCount: number;
  onNavigate: (page: string) => void;
  onLogout: () => void;
}

const navItems = [
  { id: 'dashboard', label: 'Dashboard', icon: Home },
  { id: 'alerts', label: 'Alerts', icon: Bell, badge: '3' },
  { id: 'settings', label: 'Settings', icon: Settings },
];

export const Sidebar: React.FC<SidebarProps> = ({
  currentPage,
  activeAlertsCount,
  onNavigate,
  onLogout,
}) => {
  return (
    <div className="fixed left-0 top-0 h-full w-64 bg-[#222222] border-r border-gray-600 flex flex-col">
      <div className="p-6 border-b border-gray-600">
        <div className="flex items-center space-x-3 mb-1">
          <img src="/assets/logos/foresight-white.svg" alt="Foresight" className="w-6 h-6" />
          <h1 className="text-xl font-bold text-white">Foresight</h1>
        </div>
        <p className="text-sm text-[#8b949e]">Bazaar</p>
      </div>

      <nav className="flex-1 p-4">
        <ul className="space-y-2">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = currentPage === item.id ||
              (currentPage === 'alert-details' && item.id === 'alerts');
            return (
              <li key={item.id}>
                <button
                  onClick={() => onNavigate(item.id)}
                  className={`w-full flex items-center space-x-3 px-3 py-2 rounded-lg text-left transition-colors ${
                    isActive
                      ? 'bg-[#1A1A1A] text-white'
                      : 'text-[#8b949e] hover:bg-[#1A1A1A] hover:text-gray-200'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="flex-1">{item.label}</span>
                  {item.id === 'alerts' && activeAlertsCount > 0 && (
                    <span className="bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold" style={{fontSize: '12px', lineHeight: '1'}}>
                      {activeAlertsCount}
                    </span>
                  )}
                  {item.badge && item.id !== 'alerts' && (
                    <span className="bg-red-500 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center font-bold" style={{fontSize: '12px', lineHeight: '1'}}>
                      {item.badge}
                    </span>
                  )}
                </button>
              </li>
            );
          })}
        </ul>
      </nav>

      <div className="p-4 border-t border-gray-700">
        <div className="text-xs text-[#8b949e] mb-3">
          <div>Status: <span className="text-green-400">Operational</span></div>
          <div>Last sync: 2 min ago</div>
        </div>
        <div className="-mx-4 border-t border-gray-700 px-4 pt-3">
          <div className="space-y-2">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
              }}
              className="flex items-center space-x-2 text-[#8b949e] hover:text-gray-200 text-sm transition-colors duration-200"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              <span>Company Profile</span>
            </a>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                onLogout();
              }}
              className="flex items-center space-x-2 text-[#8b949e] hover:text-gray-200 text-sm transition-colors duration-200"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
              </svg>
              <span>Log out</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
